import ApiService from '@/api/api_service';
import {
  CallTargetApi,
  ProductCategoryApi,
  ProductApi,
  ProductCategoryStatusApi,
  type ProductCategoryApiPostProductCategoryRequest,
  type ProductCategoryApiPutProductCategoryRequest,
  type ProductCategoryApiDeleteProductCategoryRequest,
  type ProductApiPostProductRequest,
  type ProductApiPutProductRequest,
  type ProductApiDeleteProductRequest,
  type ProductCategoryStatusApiPostProductCategoryStatusRequest,
  type ProductCategoryStatusApiPutProductCategoryStatusRequest,
  type ProductCategoryStatusApiDeleteProductCategoryStatusRequest,
} from '@/api/openapi';

export class ProductCategoryApiService extends ApiService {
  productCategoryApi = new ProductCategoryApi(undefined, this.baseUrl, this.httpInstance);
  productApi = new ProductApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getProductCategories() {
    return this.productCategoryApi.getProductCategories();
  }

  async postProductCategory(request: ProductCategoryApiPostProductCategoryRequest) {
    return this.productCategoryApi.postProductCategory(request);
  }

  async putProductCategory(request: ProductCategoryApiPutProductCategoryRequest) {
    return this.productCategoryApi.putProductCategory(request);
  }

  async deleteProductCategory(request: ProductCategoryApiDeleteProductCategoryRequest) {
    return this.productCategoryApi.deleteProductCategory(request);
  }

  async postProduct(request: ProductApiPostProductRequest) {
    return this.productApi.postProduct(request);
  }

  async putProduct(request: ProductApiPutProductRequest) {
    return this.productApi.putProduct(request);
  }

  async deleteProduct(request: ProductApiDeleteProductRequest) {
    return this.productApi.deleteProduct(request);
  }
}

export class ProductCategoryStatusApiService extends ApiService {
  api = new ProductCategoryStatusApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getProductCategoryStatuses() {
    return this.api.getProductCategoryStatuses();
  }

  async postProductCategoryStatus(request: ProductCategoryStatusApiPostProductCategoryStatusRequest) {
    return this.api.postProductCategoryStatus(request);
  }

  async putProductCategoryStatus(request: ProductCategoryStatusApiPutProductCategoryStatusRequest) {
    return this.api.putProductCategoryStatus(request);
  }

  async deleteProductCategoryStatus(request: ProductCategoryStatusApiDeleteProductCategoryStatusRequest) {
    return this.api.deleteProductCategoryStatus(request);
  }
}

export class CallTargetProductCategoryAssociationApiService extends ApiService {
  api = new CallTargetApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getAssociations(callTargetId: number) {
    return this.api.getCallTargetProductCategoryAssociations({ callTargetId });
  }

  async createAssociation(callTargetId: number, productCategoryId: number, productCategoryStatusId: number) {
    return this.api.createCallTargetProductCategoryAssociation({
      callTargetId,
      createCallTargetProductCategoryAssociationRequest: {
        productCategoryAssociation: {
          productCategoryId,
          productCategoryStatusId,
        },
      },
    });
  }

  async updateAssociationStatus(id: number, productCategoryStatusId: number) {
    return this.api.updateCallTargetProductCategoryAssociation({
      id,
      updateCallTargetProductCategoryAssociationRequest: {
        productCategoryAssociation: {
          productCategoryStatusId,
        },
      },
    });
  }

  async createProductAssociation(callTargetProductCategoryAssociationId: number, productId: number) {
    return this.api.createCallTargetProductAssociation({
      callTargetProductCategoryAssociationId,
      createCallTargetProductAssociationRequest: {
        productAssociation: {
          productId,
        },
      },
    });
  }

  async deleteProductAssociation(callTargetProductCategoryAssociationId: number, id: number) {
    return this.api.deleteCallTargetProductAssociation({
      callTargetProductCategoryAssociationId,
      id,
    });
  }

  async deleteAssociation(id: number) {
    return this.api.destroyCallTargetProductCategoryAssociation({ id });
  }
}
